import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PolicyDetailsService } from '../services/policydetails.service';
import * as Chart from 'chart.js';

@Component({
  selector: '',
  template: '',
})
export class MyCustomersSearchHandler extends BaseSearchComponent<PolicyDetailsService> implements OnInit {
  private chart: Chart;
  public customers: any[] = [];
  public topCustomers: any[] = [];
  public filteredCustomers: any[] = [];
  public topCustomerChart: any;
  birthdays: any[] = [];
  anniversaries: any[] = [];
  newClients: any[] = [];
  public currentSelectedTheme;

  constructor(
    public service: PolicyDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.currentSelectedTheme = this.settingService.getSessionStorageValue('currentSelectedTheme');
    if (
      (this.currentSelectedTheme != undefined || this.currentSelectedTheme != null) &&
      this.currentSelectedTheme.endsWith('.css')
    ) {
      this.currentSelectedTheme = this.currentSelectedTheme.replace('.css', '');
    }
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('myCustomers');
    return header;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getMyCustomer();
    }, 10);
  }

  getMyCustomer() {
    this.service.getMyCustomer().subscribe((res: any) => {
      if (res?.data) {
        this.customers = res.data.AllCustomers || [];
        this.topCustomers = res.data.TopCustomers || [];

        this.filteredCustomers = this.customers;
        this.birthdays =
          res.data.eventsThisMonth?.birthdays?.map((b: any) => ({
            dob: b.date,
            name: b.name,
            phone: b.mobile,
            email: b.email,
          })) || [];

        this.anniversaries =
          res.data.eventsThisMonth?.anniversaries?.map((a: any) => ({
            date: a.date,
            name: a.name,
            phone: a.mobile,
            email: a.email,
          })) || [];

        this.newClients =
          res.data.NewBusinessCustomers?.map((n: any) => ({
            issuedOn: this.settingService.getDateFormatted(n.IssueDate),
            holder: n.PolicyHolder,
            policyNo: n.PolicyNumber,
          })) || [];

        this.renderChart();
      }
    });
  }

  filterCustomers(searchText: string) {
    this.filteredCustomers = this.customers.filter((c) =>
      c['Customer Name']?.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  renderChart() {
    if (this.topCustomerChart) this.topCustomerChart.destroy();

    const labels = this.topCustomers.map((c) => c.Name);
    const data = this.topCustomers.map((c) => c.TotalPremium);
    this.topCustomerChart = new Chart('barChart', {
      type: 'horizontalBar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Top Customers',
            backgroundColor: '#1976d2',
            data: data,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false, fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000' },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
              },
              ticks: {
                beginAtZero: true,
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                callback: function (value, index, values) {
                  value = value.toString();
                  let value1 = value.split(/(?=(?:...)*$)/);
                  value = value1.join(',');
                  return value;
                },
              },
              gridLines: {
                color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : '#000',
                drawBorder: true,
                lineWidth: 1,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                stepSize: this.settingService.isMobileViewRendered() ? 100 : 50,
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                beginAtZero: true,
                min: 0,
              },
              gridLines: {
                color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                drawBorder: true,
                lineWidth: 1,
              },
              scaleLabel: {
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
              },
            },
          ],
        },
        plugins: {
          datalabels: false,
        },
      },
    });
  }
}
